<template>
  <CCol>
    <CRow>
      <CCol sm="12">
        <CRow v-if="loading">
          <CCol class="d-flex flex-column justify-content-center align-items-center w-100">
            <CSpinner class="my-3" color="primary" />
          </CCol>
        </CRow>

        <CRow class="justify-content-between align-items-start" v-show="!loading" v-if="viewReset">
          <CCol v-if="messages.length" sm="12">
            <transition name="fade">
              <MenssageAlert :messages="messages" />
            </transition>
          </CCol>

          <CCol v-for="target in shedules" :key="target.title" sm="6" class="p-0 text-gray-600 cardChannel">
            <CInputRadio
              type="radio"
              :id="target.name"
              :value="target.name"
              name="target"
              :checked="time.targetTime == target.name"
              @update:checked="(state) => check(state, target.name)"
              class="cardChannel__checkRadio"
              :class="{ 'cardChannel__checkRadio--active': targetTime == target.name }"
              hidden
            />
            <!--TODO melhorar forma de capturar o click -->
            <div class="cardChannel__child m-1" @click="check(true, target.name)">
              <label :for="target.name" class="d-flex justify-content-center align-items-center flex-column p-3">
                <CIcon :name="target.name" :height="32" viewBox="0 0 32 32" />
                <span class="font-weight-normal font-md text-center">
                  {{ target.title }}
                </span>
              </label>
            </div>
          </CCol>
          <CCol sm="12" class="py-5" v-if="targetTime == 'schedule'">
            <h6 class="font-weight-normal mb-3">
              {{ $t('campaign.creator.blockLibrary.time.to-schedule') }}
            </h6>
            <v-date-picker
              :locale="lang"
              class="date-picker"
              color="purple"
              is-expanded
              label="Date"
              rounf
              is-inline
              v-model="date"
              :input-debounce="500"
              addInputClasses="p-5 date-picker__input"
              :min-date="new Date()"
              :timezone="'UTC'"
              @dayclick="(obj) => setDate(obj)"
            />
          </CCol>

          <CCol sm="12" v-if="targetTime == 'schedule'">
            <CRow>
              <CCol sm="12" class="mb-3">
                <!-- <div v-if="showDefaultTimeZone">
                  <div class="d-flex justify-content-between mb-3">
                    <input :value="userTimeZone" class="form__input--border px-2" custom readonly style="width: 170px" />
                    <CButton color="primary" @click="dropDownTimeZone = !dropDownTimeZone">
                      {{ $t('campaign.creator.blockLibrary.time.button.time-zone-change') }}
                    </CButton>
                  </div>
                </div> -->

                <!-- <div v-if="showDropDownTimeZone"> -->
                <div>
                  <label for=""> {{ $t('campaign.creator.blockLibrary.time.label.time-zone') }} </label>
                  <!-- <multiselect
                    v-model="timeZone"
                    :options="timeZones"
                    :customLabel="(option) => option.label"
                    :show-labels="false"
                    track-by="value"
                    label="label"
                    class="multiselect--custom"
                    clear-select
                    :placeholder="$t('settings.profile.basicInfo.label.timeZone')"
                    @select="selectTimezone"
                  >
                  </multiselect> -->
                  <v-select
                    :clearable="false"
                    :options="timeZones"
                    v-model="timeZone"
                    :placeholder="$t('settings.profile.basicInfo.label.timeZone')"
                    @input="saveContent"
                  />
                </div>
              </CCol>
              <CCol sm="6" class="mb-3">
                <label for="">
                  {{ $t('campaign.creator.blockLibrary.time.shipping-time') }}
                </label>
                <vue-timepicker v-model="shippingTime" @change="saveContent" @open="scrollToSpaceArea()" fixed-dropdown-button hide-clear-button>
                  <template v-slot:dropdownButton>
                    <CIcon name="time" :height="20" :width="20" viewBox="0 0 32 32" />
                  </template>
                </vue-timepicker>
              </CCol>
            </CRow>
            <div ref="spaceArea" v-if="activeBlock.type != 'SMS'" style="height: 140px"></div>
            <CRow ref="advanced" class="text-black-50" v-if="activeBlock.type == 'SMS'">
              <CCol sm="12" class="mb-4">
                <span class="text-uppercase line-custom">
                  {{ $t('campaign.creator.blockLibrary.time.title-advanced') }}
                </span>
              </CCol>
              <CCol sm="6">
                <label class="w-100" for=""> {{ $t('campaign.creator.blockLibrary.time.label.start-time') }}</label>
                <vue-timepicker
                  v-model="startTime"
                  @change="changeHandler($event, 'startTime')"
                  @open="scrollToAdavenced()"
                  fixed-dropdown-button
                  hide-clear-button
                >
                  <template v-slot:dropdownButton>
                    <CIcon name="time" :height="20" :width="20" viewBox="0 0 32 32" />
                  </template>
                </vue-timepicker>
              </CCol>
              <CCol sm="6">
                <label class="w-100" for="">{{ $t('campaign.creator.blockLibrary.time.label.end-time') }}</label>
                <vue-timepicker
                  v-model="endTime"
                  @change="changeHandler($event, 'endTime')"
                  @open="scrollToAdavenced()"
                  fixed-dropdown-button
                  hide-clear-button
                >
                  <template v-slot:dropdownButton>
                    <CIcon name="time" :height="20" :width="20" viewBox="0 0 32 32" />
                  </template>
                </vue-timepicker>
              </CCol>
              <CCol sm="12">
                <p v-if="startTime && endTime && timeZone" class="mt-4">
                  {{ $t('campaign.creator.blockLibrary.time.will-be-sent-between', [startTime, endTime, timeZone.label]) }}
                </p>
              </CCol>
              <CCol sm="12" class="my-3">
                <CInputCheckbox
                  @change="saveContent"
                  :checked="isWorkingDays"
                  @update:checked="(value) => (isWorkingDays = value)"
                  :label="$t('campaign.creator.blockLibrary.time.on-weekends')"
                  custom
                  addLabelClasses="text-gray-600 d-flex align-items-center"
                />
              </CCol>
            </CRow>
          </CCol>
        </CRow>
      </CCol>
    </CRow>
  </CCol>
</template>

<script>
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
import MenssageAlert from '@/components/MenssageAlert'
import { mapGetters } from 'vuex'
import services from '@/services.js'
import { DateTime } from 'luxon'
import vSelect from 'vue-select'

export default {
  name: 'Time',
  components: {
    MenssageAlert,
    VueTimepicker,
    vSelect,
  },
  props: {
    time: {
      type: Object,
    },
    indice: {
      type: Number,
    },
  },

  data() {
    return {
      viewReset: false,
      locale: '',
      dropDownTimeZone: false,
      messages: [],
      loading: false,
      targetTime: '',
      date: new Date(),
      timeZone: {
        label: '',
        value: '',
      },
      shippingTime: '',
      startTime: '',
      endTime: '',
      isWorkingDays: false,
      shedules: [
        { name: 'sendNow', title: this.$t('campaign.creator.blockLibrary.shedules.now') },
        { name: 'schedule', title: this.$t('campaign.creator.blockLibrary.shedules.schedule') },
      ],

      timeZones: [],
    }
  },

  created() {
    this.getTimeZone()
  },

  mounted() {
    this.$nextTick(
      function () {
        this.viewReset = true
      }.bind(this),
    )
  },

  destroy() {
    this.$nextTick(function () {}.bind(this))
  },

  computed: {
    ...mapGetters({
      lang: 'getLang',
    }),

    userTimeZone() {
      return this.$store.state.auth.user.timeZone
    },

    showDefaultTimeZone() {
      return this.userTimeZone && this.dropDownTimeZone == false
    },

    showDropDownTimeZone() {
      return !this.userTimeZone || this.dropDownTimeZone
    },

    activeBlock() {
      return this.$store.state.campaign.activeBlock
    },
  },

  methods: {
    scrollToAdavenced() {
      this.$refs.advanced.scrollIntoView()
    },
    scrollToSpaceArea() {
      this.$refs.spaceArea.scrollIntoView()
    },
    getTimeZone() {
      services.timeZones().then((res) => {
        let list = res.data.data.sort((elm1, elm2) => {
          if (elm1.offsetInMinutes > elm2.offsetInMinutes) return 1
          if (elm1.offsetInMinutes == elm2.offsetInMinutes) return 0
          if (elm1.offsetInMinutes < elm2.offsetInMinutes) return -1
        })

        this.timeZones = list.map((elm) => {
          elm.label = elm.timeZoneDescription
          elm.value = elm.timeZoneId
          return {
            label: `${elm.timeZoneDescription} + ${elm.timeZoneId}`,
            value: elm.timeZoneId,
          }
        })

        if (!this.time.timeZone) {
          let userTimezone = this.$store.state.auth.user.timeZone
          if (userTimezone)
            this.timeZone =
              this.timeZones.find((elm) => elm.value == userTimezone) || this.timeZones.find((elm) => elm.value == this.time.timeZone) || {}
        }

        this.resetValues()
        // .sort((countryA, countryB) => {
        //   const UTC_A = Number(countryA.label.split(' ')[1].replace('h', ' '))
        //   const UTC_B = Number(countryB.label.split(' ')[1].replace('h', ' '))

        //   return UTC_A - UTC_B
        // })
      })
      // .finally(() => {
      //   // this.timeZone = this.timeZones.find((elm) => elm.value == this.time.timeZone) || {}
      //   let userTimezone = this.$store.state.auth.user.timeZone
      //   this.timeZone =
      //     this.timeZones.find((elm) => elm.value == userTimezone) || this.timeZones.find((elm) => elm.value == this.time.timeZone) || {}

      //   this.resetValues()
      // })
    },

    changeHandler(event, input) {
      this[input] = event.displayTime

      if (input == 'startTime') {
        if (this.startTime != '' && this.endTime != '') {
          if (this.compareStartTimeAndEndTime()) {
            this.endTime = '23:59'
          }
        }
      }

      if (input == 'endTime') {
        if (this.startTime != '' && this.endTime != '') {
          if (this.compareStartTimeAndEndTime()) {
            this.startTime = '00:00'
          }
        }
      }

      this.startTime = this.startTime.replaceAll('m', '0').replaceAll('H', '0')
      this.endTime = this.endTime.replaceAll('m', '0').replaceAll('H', '0')

      this.saveContent()
    },

    check(value, name) {
      if (value) {
        this.targetTime = name

        if (this.targetTime == 'sendNow') {
          this.$store.dispatch('campaign/saveTime', {
            card: 'date',
            time: {
              scheduleDate: '',
              targetTimeType: this.targetTime,
              beginTime: '',
              endTime: '',
              scheduleTime: '',
              isWorkingDays: false,
              timeZone: '',
            },
            indice: this.indice,
          })
          return
        }

        this.saveContent()
      }
    },

    getNowHour() {
      const DATE = new Date()
      let hour = this.addZero(DATE.getHours())
      let min = this.addZero(DATE.getMinutes())

      return `${hour}:${min}` || '00:00'
    },

    addZero(i) {
      if (i < 10) {
        i = '0' + i
      }
      return i
    },

    setDate(objCalendar) {
      if (objCalendar) {
        if (!objCalendar.isDisabled) {
          // this.date = new Date(objCalendar.date.getTime() - objCalendar.date.getTimezoneOffset() * 60000).toISOString()
          this.date = objCalendar.date
          this.saveContent()
        }
        return
      }

      this.date = this.time.date
    },

    compareStartTimeAndEndTime() {
      return (
        new Date('1/1/1988 ' + this.startTime) > new Date('1/1/1988 ' + this.endTime) ||
        new Date('1/1/1988 ' + this.startTime).toString() == new Date('1/1/1988 ' + this.endTime).toString()
      )
    },

    saveContent() {
      let dateTime = DateTime.fromJSDate(this.date)

      var obj = {
        card: 'date',
        time: {
          scheduleDate: this.date,
          localTimezoneOffset: dateTime.offset,
          localTimezone: dateTime.zoneName,
          targetTimeType: this.targetTime,
          beginTime: this.startTime,
          endTime: this.endTime,
          scheduleTime: this.shippingTime,
          isWorkingDays: this.isWorkingDays || false,
          timeZone: this.timeZone.value,
        },
        indice: this.indice,
      }
      this.$store.dispatch('campaign/saveTime', obj)
    },

    resetValues() {
      if (this.indice == null) {
        this.getTimeZone()
        return
      }

      this.$nextTick(function () {
        this.date = this.time.scheduleDate ? new Date(this.time.scheduleDate) : new Date()

        if (this.time.timeZone) this.timeZone = this.timeZones.find((elm) => elm.value == this.time.timeZone) || {}
        else this.timeZone = this.timeZones.find((elm) => elm.value == this.$store.state.auth.user.timeZone) || {}

        this.targetTime = this.time.targetTimeType || ''
        this.shippingTime = this.time.scheduleTime || '00:00'
        this.startTime = this.time.beginTime || null
        this.endTime = this.time.endTime || null
        this.isWorkingDays = this.time.isWorkingDays || false
      })
    },
  },

  // watch: {
  //   time: {
  //     handler() {
  //       this.resetValues()

  //       if (this.$store.state.auth.user.timeZone) this.timeZone.value = this.$store.state.auth.user.timeZone
  //     },
  //     deep: true,
  //   },
  // },
}
</script>

<style lang="scss" scoped>
.date-picker {
  border-radius: 0px;

  span.vc-day-content {
    font-weight: normal;
    color: (--gray-500);
  }
}

.line-custom {
  display: flex;
  align-items: center;
  &:after {
    content: '';
    width: 100%;
    height: 1px;
    background: var(--gray-400);
    margin-left: 0.5rem;
  }
}

.form__input--border {
  border: 1px solid var(--gray-500) !important;

  &:focus {
    outline: none;
  }
}
</style>

<style lang="scss">
.vue__time-picker-dropdown .select-list,
.vue__time-picker .dropdown .select-list {
  width: 100%;
}

.vue__time-picker-dropdown ul li:not([disabled]).active,
.vue__time-picker-dropdown ul li:not([disabled]).active:focus,
.vue__time-picker-dropdown ul li:not([disabled]).active:hover,
.vue__time-picker .dropdown ul li:not([disabled]).active,
.vue__time-picker .dropdown ul li:not([disabled]).active:focus,
.vue__time-picker .dropdown ul li:not([disabled]).active:hover {
  background: $primary;
  color: #fff;
}

.vue__time-picker,
.vue__time-picker-dropdown,
.vue__time-picker .dropdown {
  max-width: 120px;
}

.vue__time-picker input.display-time {
  font-family: 'Nunito Sans', sans-serif;
  color: var(--gray-base);
  width: 100%;

  &:focus {
    outline: none;
  }
}
</style>
